import React, {Component} from 'react';
import {Link} from 'react-router'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as invoiceActions from '../../../actions/invoices';
import DataTable from '../../../components/data-table/data-table';
import LocalizedStrings from '../../../localization/strings';
import moment from 'moment';
import Icon from '../../../components/icon';

class InvoicesContainer extends Component {

  componentWillMount() {
    this.fetch({});
  }

  fetch(params) {
    const fetchParams = {
      ...this.state,
      ...params
    }
    this.setState(fetchParams);
    this.props.actions.fetchInvoicesPaginated(fetchParams.page, fetchParams.size);
  }

  render() {
    const {items, total, page, loading, total_pages} = this.props.invoices;

    var config = {
      cols: [
        {
          value: 'serial',
          header: LocalizedStrings.serialNumber
        },
        {
          value: 'amount',
          header: LocalizedStrings.amount
        },
        {
          value: (item) => {
            return moment(item.invoice_date).format('YYYY-MM-DD')
          },
          header: LocalizedStrings.date
        },
        {
          value: (item) => {
            return item.payment.participants.map(item=>{
              return  <Link to={`/admin/participants/${item.id}`}>{item.name}</Link>
            });
          },
          header: LocalizedStrings.participants
        },
        {
          value: (item) => {
            return item.payment.participants.map(item=>{
              return  <Link to={`/admin/stages/${item.stage.id}`}>{item.stage.name}</Link>
            });
          },
          header: LocalizedStrings.stage
        },
        {
          value: (item) => {
            return (
              <Link to={`/api/invoice/export/${item.id}`} className="btn" target="_blank">
                {LocalizedStrings.preview}
              </Link>
            )
          },
          header: LocalizedStrings.actions
        }
      ]
    };
    return (
      <div>
        <h3>
          {LocalizedStrings.invoices}
        </h3>
        <div className="panel">
          <div className="panel-body">
            <div>
              <Link to={'/api/invoices/export'} target="_blank">
                {LocalizedStrings.export}
                <Icon icon="xlsx-file" size="ss"/>
              </Link>
            </div>

            <DataTable loading={loading} config={config} items={items} page={page} total={total}
                       totalPages={total_pages} loadAction={this.fetch.bind(this)}></DataTable>
          </div>
        </div>
      </div>

    )
  }
}

export default connect(function (state) {
  return {invoices: state.invoices.invoices};
}, function (dispatch) {
  return {
    actions: bindActionCreators({
      ...invoiceActions
    }, dispatch)
  };
})(InvoicesContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/invoices/invoices-container.js